function snakeToCamel(s){
    return s.replace(/(\_\w)/g, function(m){return m[1].toUpperCase();});
}

function camelToSnake(string) {
       return string.replace(/[\w]([A-Z])/g, function(m) {
           return m[0] + "_" + m[1];
       }).toLowerCase();
}

export function jsonIn(json){
  let output = {}
  Object.keys(json).forEach((key) => {
    let value = json[key]
    let newKey = key.includes('_') ? snakeToCamel(key) : key
    output[newKey] = value
  })
  return output
}

function hasUpperCase(str){
  return /[A-Z]/.test(str)
}

export function jsonOut(json){
  let output = {}
  Object.keys(json).forEach((key) => {
    let value = json[key]
    let newKey = hasUpperCase(key)  ? camelToSnake(key) : key
    output[newKey] = value
  })
  return output
}
